// Copyright (c) 2022 Sagacity Solutions Inc. All right reserved.
'use strict'        ;

import Vue from "vue";
//import api from "@/api"
import npAPI from "@/api/notification-profile"

export default {
  namespaced: true,
  state: {
    profiles: {},
  },
  getters: {
    profileOptions(state) {
      const profiles = state.profiles;
      return Object.keys(profiles).map(k => {
        const v = profiles[k];
        return {value: v.ID, text: v.Name };
      });
    }
  },
  mutations: {
    update(state, { name, profile}) {
      console.log(name, profile);
      Vue.set(state.profiles, name, profile);
    },
    delete(state, name) {
      delete(state.profiles[name]);
    }
  },
  actions: {
    async get({commit}) {
      const profiles = await npAPI.get();
      console.log(profiles);
      profiles.forEach((profile) => {
        commit('update', {name: profile.Name, profile})
      })
    },
    async add({commit}, name) {
      const profile = await npAPI.create({Name: name, Category: 'custom', Enable: false, Notifications:[]})
      commit('update', { name, profile });
    },
    async save({state, commit}, {name, profile}) {
      const p = state.profiles[name];
      if (p) {
        const id = p.ID;
        const np = await npAPI.update(id, Object.assign({}, p, profile));
        commit('update', {name, profile: np});
        return;
      }
      throw new Error('profile with that name does not exist');
    },
    async delete({state, commit}, name) {
      const p = state.profiles[name];
      if (p) {
        const id = p.ID;
        await npAPI.delete(id);
        commit('delete', name);
        return;
      }
      throw new Error('profile with that name does not exist');
    }
  }
}
